import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { Icon, Text, useSettings, Utils } from 'app/main/components';
import { ViewList } from 'app/main/components/page-layouts';

import { showCompaniesMergeDialog } from '../../components/CompaniesMergeDialog';

function CompaniesDuplicatesListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	// const showMergeDialog = () =>
	// 	dispatch(
	// 		showCompaniesMergeDialog({
	// 			compUid: props.model.companies[0].comp_uid,
	// 			defaultFilters: [
	// 				{
	// 					filt_field: 'comp_vatnumber',
	// 					filt_clause: 'equals',
	// 					filt_value: props.model.vatnumber
	// 				}
	// 			],
	// 			updateRefresh: props.buttonProps.updateRefresh
	// 		})
	// 	);

	return (
		<GridListItem
		// secondaryAction={
		// 	<IconButton onClick={showMergeDialog}>
		// 		<Icon icon="call-merge" />
		// 	</IconButton>
		// }
		>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 960 ? 2 : props.width >= 600 ? 4 : 12}>
					{/* VATNUMBER */}
					<Text className="font-600" variant="subtitle2">
						{t('DETAILS_COMPANIES_FIELD_VAT')}
					</Text>
					<Text className="font-600" variant="subtitle2">
						{props.model.vatnumber}
					</Text>
				</Grid>
				<Grid size={props.width >= 960 ? 10 : props.width >= 600 ? 8 : 12}>
					<Text className="font-600" variant="subtitle2">
						{t('MODULE_COMPANIES_NAME')}
					</Text>
					{/* COMPANIES */}
					{props.model.companies?.map(company => (
						<Text
							key={company.comp_uid}
							className="w-fit font-400"
							variant="subtitle2"
							color="text.secondary"
							to={{ module: 'companies', uid: company.comp_uid }}
						>
							{company.comp_title}
							<Icon className="ml-4 inline" icon="open-in-new" size={14} />
						</Text>
					))}
				</Grid>
			</Grid>
		</GridListItem>
	);
}

export default function CompaniesDuplicatesView() {
	return (
		<ViewList
			module="companies"
			storedProcedure="st_companies_list_duplicates"
			itemLayout={CompaniesDuplicatesListItem}
			showExportButton={false}
		/>
	);
}
